import { ReactComponent as ShopIcon } from 'assets/icons/shop/shop.svg';
import { ReactComponent as ShoppingCartIcon } from 'assets/icons/shop/shopping-cart.svg';

export const shop = {
  shop: ShopIcon,
  'shopping-card': ShoppingCartIcon,
};
